import React from 'react';
import logo from '../media/Logos/logo-dabi-gris.png';
import "../scss/Components/_errorscreen.scss"


function ErrorScreen() {
  return (
    <div className="error-screen">
      <img src={logo} alt="Logo de DABI" className="logo" />
      <h1 className='h1-error-screen'>No tienes permisos para acceder.</h1>
      <p className='p-error-screen'>Código de error: 403</p>
      <p className='p-error-screen'>Recarga la página o ponte en contacto con un administrador en caso de que consideres que es un error.</p>
      <a className='a-error-screen' href="/dashboard">Volver a la página principal</a>
    </div>
  );
}

export default ErrorScreen;